import { lazy, type ComponentType } from "react";
import { isChunkLoadError, reloadForChunkError } from "./chunk-reload";

/**
 * VIB-945: Som `React.lazy`, men auto-reloader siden ved chunk-load-feil
 * (stale bundle etter deploy). Hvis reload allerede er brukt denne økten,
 * re-thrower vi feilen så error boundary fanger den i stedet for å loope.
 *
 * Mens reloaden pågår returnerer vi en evig pending promise, slik at React
 * holder Suspense-fallbacken oppe i stedet for å blinke error boundary først.
 */
export function lazyWithReload<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    factory().catch((error) => {
      if (isChunkLoadError(error) && reloadForChunkError()) {
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }),
  );
}
